import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue"; 
  import { QInput } from "quasar";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EmailInput',
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const rules = computed(() => [
    (val: string) => (props.required && !!val) || !props.required || "Required",
    (val: string) => (!props.required && !val) || (!!val && /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(val)) || "Invalid email format"
  ])

  const value = computed<string>({
    get() {
      return props.modelValue ?? ""
    },
    set(value: string) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit
  
  const emailInputRef = ref<QInput | null>(null);
  function validate() {
    return emailInputRef.value!.validate();
  }
  __expose({
    validate
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QInput), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      ref_key: "emailInputRef",
      ref: emailInputRef,
      type: "email",
      "data-cy": "emailInput",
      rules: rules.value,
      dense: "",
      "data-clarity-mask": "True",
      outlined: ""
    }, null, 8, ["modelValue", "rules"])
  ], 64))
}
}

})